module.exports = __webpack_public_path__ + "assets/img/size.7820f4ad.svg";